import { type ReactNode } from 'react'
import './SummaryItem.scss'
import * as S from './SummaryItem.styles'
import classNames from 'classnames'

interface SummaryItemProps {
  highlighted?: boolean
  grayed?: boolean
  strong?: boolean
  text?: string
  highlightedText?: ReactNode[]
  action?: () => void
  actionText?: string
  fullWidth?: boolean
  children?: ReactNode
  className?: string
  testId?: string
  description?: string
  descriptionPrefixNode?: ReactNode
}

function SummaryItem({
  highlighted,
  grayed,
  strong,
  text,
  highlightedText,
  action,
  actionText,
  fullWidth,
  children,
  className,
  testId,
  description,
  descriptionPrefixNode,
}: SummaryItemProps) {
  const itemClass = classNames(
    'summary-item',
    className,
    { highlighted },
    { grayed },
    { strong }
  )

  const textClass = classNames('text', { 'full-width': fullWidth })

  return (
    <S.Wrapper>
      <div className={itemClass} data-testid={testId}>
        <div className={textClass}>
          {text ? (
            <S.Text
              data-testid={`${testId}-text`}
              $withSubtitle={!!highlightedText || !!description}
            >
              {text}
            </S.Text>
          ) : null}
          {description && (
            <S.DescriptionWrapper>
              {descriptionPrefixNode}
              {description}
            </S.DescriptionWrapper>
          )}
          {action ? (
            <S.Div $strong={strong} className="summary-action" onClick={action}>
              {actionText}
            </S.Div>
          ) : null}
        </div>
        <S.BoldDiv $strong={strong} className="value">
          {children}
        </S.BoldDiv>
      </div>
      {!!highlightedText?.length &&
        highlightedText.map((highlightedTextItem, index) => (
          <S.SummaryHighlightedText
            key={index}
            className="summary-item text highlighted"
          >
            {highlightedTextItem}
          </S.SummaryHighlightedText>
        ))}
    </S.Wrapper>
  )
}

export default SummaryItem
